import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Refresh from '@material-ui/icons/Refresh';
import CommentCard from './CommentCard';
import CommentForm from './CommentForm';

const useStyles = makeStyles(theme => ({
  root: {
    background: 'linear-gradient(45deg, #efefff 30%, #efffff 90%)',
  },
  snackbar: {
    background: 'linear-gradient(45deg, #f44336 30%, #d32f2f 90%)'
  },
  item: {
    borderTop: 'solid 1px #e1e1ff',
  },
  grid: {
    color: "#777766"
  }
}));

export default function Thread({threads, contents, error, threadId, getContents}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  getContents(threadId);

  React.useEffect(() => {
    getContents(threadId);
  });

  const handleClose = () => {
    setOpen(false);
  }

  const thread = threads.find(v => v.threadId == threadId);
  const content = contents[threadId];

  return (
    <div className={classes.root}>
      <Container className={classes.root}>
        <Paper>
          <Box p={1}>
            <Typography variant="h4">{thread.title}</Typography>
            <Typography variant="subtitle1">{thread.description}</Typography>
            <Typography variant="body1">作成者:{thread.creator}  作成日:{thread.date}</Typography>
          </Box>
          <List>
          {
            content.map(v => {
              return (
                <CommentCard {...v} />
              );
            })
          }
          </List>
        </Paper>
        <Box pt={.5}>
          <CommentForm threadId={threadId} />
        </Box>
      </Container>
      <Snackbar
        ContentProps={classes.error}
        anchorOrigin={{vertical: "top", horizontal:"center"}}
        open={open && error}
        onClose={handleClose}
      >
        <SnackbarContent
          className={classes.snackbar}
          message={
            <Typography variant="body1">{error.status} ({error.statusText})</Typography>
          }
          action={
            <IconButton onClick={() => window.location.reload(true)}>
              <Refresh />
            </IconButton>
          }
        />
      </Snackbar>
    </div>
  );
}
